const messagesDiv = document.getElementById("messages");
let currentMessageIndex = 0;

// Предустановленные вопросы и ответы
const questionsAndAnswers = {
    question1: [
        'Привет! Это первый предустановленный вопрос.',
        'Вот подробная информация...',
        'Хотите узнать ещё?',
        () => showActionButtons()
    ],
    question2: [
        'Это второй предустановленный вопрос.',
        'Дополнительная информация по запросу...',
        'Желаете продолжить диалог?',
        () => showActionButtons()
    ]
};

function appendMessage(text) {
    const messageDiv = document.createElement("div");
    messageDiv.classList.add("message");
    messageDiv.textContent = text;
    messagesDiv.appendChild(messageDiv);
    
    // Прокручиваем окно сообщений вниз
    messagesDiv.scrollTop = messagesDiv.scrollHeight;
}

function showQuestion(questionKey) {
    currentMessageIndex = 0;
    sendNextMessage(questionKey);
}

function sendNextMessage(questionKey) {
    if (currentMessageIndex >= questionsAndAnswers[questionKey].length) return;
    
    let nextItem = questionsAndAnswers[questionKey][currentMessageIndex];
    
    if (typeof nextItem === 'string') {
        appendMessage(nextItem);
        setTimeout(() => {
            currentMessageIndex++;
            sendNextMessage(questionKey); // Отправляем следующее сообщение спустя 1 секунду
        }, 1000);
    } else if (typeof nextItem === 'function') {
        nextItem(); // Выполняем функцию (например, показать кнопки действий)
    }
}

function showActionButtons() {
    const yesButton = document.createElement("button");
    yesButton.textContent = "Да";
    yesButton.onclick = function() {
        showContactForm();
    };
    
    const noButton = document.createElement("button");
    noButton.textContent = "Нет";
    noButton.onclick = function() {
        clearMessages();
    };
    
    messagesDiv.appendChild(yesButton);
    messagesDiv.appendChild(noButton);
}

function showContactForm() {
    clearMessages();
    appendMessage("Как с Вами связаться?");
    
    const messengerChoice = `
        <button onclick="selectMessenger('WhatsApp')">WhatsApp</button>
        <button onclick="selectMessenger('Telegram')">Telegram</button>
    `;
    messagesDiv.innerHTML += messengerChoice;
}

function selectMessenger(messenger) {
    const formHtml = `
        <form onsubmit="event.preventDefault(); submitForm(event)">
            Имя:<br>
            <input type="text" name="name"><br>
            Телефон:<br>
            <input type="tel" name="phone"><br>
            ${messenger}:<br>
            <textarea name="message"></textarea><br>
            <button type="submit">Отправить</button>
        </form>
    `;
    messagesDiv.innerHTML = formHtml;
}

function submitForm(event) {
    alert("Форма отправлена!");
    event.target.reset();
}

function clearMessages() {
    messagesDiv.innerHTML = '';
}